import { values } from './_helpers'

const _enum = {
  _0375: 0,
  _0500: 1,
  _0750: 2,
  _1500: 3,
  other: 4
}

const bottleVolume = { ..._enum, name: 'bottleVolume', values: values(_enum) }

export {
  bottleVolume
}
